import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useFeatureFlagsQuery } from "@/hooks/useFeatureFlagsQuery";

/**
 * Route guard for the Messaging feature. Renders children only when the `messagesEnabled`
 * feature flag is on; otherwise redirects to the dashboard. This stops the messages views
 * (member + admin) being reachable by direct URL while the flag is off. While the flag query
 * is still loading we render nothing, to avoid a flash of messaging UI before it resolves.
 */
const RequireMessagesEnabled = ({ children }: { children: ReactNode }) => {
  const { data, isLoading } = useFeatureFlagsQuery();

  if (isLoading) return null;
  if (!data?.messagesEnabled) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
};

export default RequireMessagesEnabled;
